import React, { useState, useEffect, useRef } from 'react'

import { Table, Panel, Grid, Checkbox, Icon } from 'rsuite'
import { findIndex } from 'lodash-es'
import ExpertName from '../../view/ExpertName'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import { useSelector } from 'react-redux'
import { GetBudgetYear } from '../../../utils/dataUtil'

export default function ExpertListTable({
  data: _data,
  selectedExpert,
  isEditable,
  isDisableOnline,
  // activePage = 1,
  // pageCount = 1,
  isSubProject,
  isHideWorkload,
  onClickSelect = () => {},
  onClickOnline = () => {},
  // handleChangePage = () => {},
  onReload = () => {},
  pagination = true,
  lengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ],
  loading,
  isAll,
  totalSize,
}) {
  const { Column, HeaderCell, Cell } = Table
  const SELECTED_EXPERT = 'selectedExpert'
  
  const { isExpanded } = useSelector((state) => state.schemaSidebar)

  const containerRef = useRef(null)
  const [containerWidth, setContainerWidth] = useState(0)
  const [windowWidth, setWindowWidth] = useState(0)
  const [detailWidth, setDetailWidth] = useState(500)
  const [tableData, setTableData] = useState(_data)

  const [displayLength, setDisplayLength] = useState(5)
  const [page, setPage] = useState(1)

  let _sendedExpert = []
  try {
    _sendedExpert = JSON.parse(sessionStorage.getItem(SELECTED_EXPERT)) || []
  } catch (e) {}

  const [sendedExpert, setsendedExpert] = useState(_sendedExpert.filter(i => i.sendConsiderDate))

  const handleResize = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    setTableData(_data)
  }, [_data])

  useEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth)
      setTableData([])
      setTimeout(() => {
        setTableData(tableData)
      }, 0)
    }
  }, [containerRef, windowWidth, isExpanded])

  useEffect(() => {
    let callWidth =
      containerWidth -
      50 -
      240 -
      100 -
      100 -
      (isEditable ? 100 : 0) -
      (isEditable && isSubProject ? 70 : 0)
    callWidth <= 500 ? (callWidth = 500) : callWidth
    setDetailWidth(containerWidth > 500 ? callWidth : 500)
  }, [containerWidth])

  const defaultCheckedIsSelected = (rowData) => {
    const dataIndex = findIndex(selectedExpert, { id: rowData.id })
    if (dataIndex !== -1) {
      return selectedExpert[dataIndex].isSelected
    }
    return false
  }

  const defaultCheckedIsOnline = (rowData) => {
    const dataIndex = findIndex(selectedExpert, { id: rowData.id })
    if (dataIndex !== -1) {
      return selectedExpert[dataIndex].isOnline
    }
    return rowData.isOnline
  }

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
    onReload(dataKey, 1)
  }
  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    onReload(displayLength, dataKey)
  }

  const getData = () => {
    return tableData?.filter((v, i) => {
      const start = displayLength * (page - 1)
      const end = start + displayLength
      return i >= start && i < end
    })
  }

  const ImageCell = ({ rowData, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0 }} align="center">
      <Grid fluid>
        <Icon icon="user" size="2x" style={{ marginTop: 15 }} />
        {/* rowData[dataKey] = https://image.flaticon.com/icons/png/512/149/149071.png   url นี้ไม่มีรูปภาพแล้ว */}
        {/* <Row>
          <Col
            lg={12}
            // style={
            //   {
            //     width: 40,
            //     height: 40,
            //     borderRadius: 20,
            //     marginTop: 2,
            //   }
            // }
          >
            <div style={{ marginTop: 6, marginLeft: 8 }}>
            <img src={rowData[dataKey]} width="35" />
            </div>
          </Col>
        </Row> */}
      </Grid>
    </Cell>
  )

  const SubnameCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props}>
        <Grid fluid>
          <ExpertName name={rowData[dataKey] || rowData.firstName} email={rowData.email} />
        </Grid>
      </Cell>
    )
  }

  return (
    <div ref={containerRef}>
      <Panel
        style={{ marginTop: 10 }}
        header="รายชื่อผู้ทรงคุณวุฒิ"
        collapsible
        bodyFill
        defaultExpanded
      >
        <Table
          wordWrap
          bordered
          height={400}
          data={pagination && isAll ? getData() : tableData || []}
          // data={tableData || []}
          loading={loading}
          headerHeight={80}
        >
          <Column width={50} align="center">
            <HeaderCell>
              <span></span>
            </HeaderCell>
            <ImageCell dataKey="avartar" />
          </Column>

          <Column width={250}>
            <HeaderCell>
              <span>ผู้ทรงคุณวุฒิ</span>
            </HeaderCell>
            <SubnameCell dataKey="name" />
          </Column>
          {/* <Column minWidth={170} flexGrow={1}> */}
          {/* <Column width={detailWidth / 2}>
            <HeaderCell>
              <span>ความถนัด/ความเชี่ยวชาญ</span>
            </HeaderCell>
            <Cell dataKey="status" />
          </Column> */}
          {/* <Column minWidth={150} flexGrow={1}> */}
          <Column width={detailWidth / 2.5}>
            <HeaderCell>
              <span>ประเภทบัญชี</span>
            </HeaderCell>
            <Cell dataKey="group" />
          </Column>
          {/* <Column width={100} align="center">
            <HeaderCell>
              <span>คำสั่งแต่งตั้ง</span>
            </HeaderCell>
            <Cell dataKey="stars" />
          </Column> */}
          {!isHideWorkload && (
            <Column width={240} align="center">
              <HeaderCell>
                <span>จำนวนโครงการปี {GetBudgetYear()} <br/>(อยู่ระหว่าง/แล้วเสร็จ)</span>
              </HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <span>
                      {rowData.workLoadRequest}/{rowData.workLoadApprove}
                    </span>
                  )
                }}
              </Cell>
            </Column>
          )}
          <Column width={145} align="center">
            <HeaderCell>
              <span>ปีงบประมาณ</span>
            </HeaderCell>
            <Cell dataKey="year" />
          </Column>
          {isEditable && (
            <Column width={100} fixed="right">
              <HeaderCell>
                <span>เลือก</span>
              </HeaderCell>
              <Cell>
                {(rowData) => {
                  //console.log('rowData', rowData)
                  return (
                    <Checkbox
                      value={rowData.id}
                      checked={defaultCheckedIsSelected(rowData)}
                      onChange={(value, checked) => {
                        onClickSelect(value, checked, rowData)
                      }}
                      disabled={sendedExpert.find(i => i.id == rowData.id)}
                    />
                  )
                }}
              </Cell>
            </Column>
          )}
          {(isEditable && !isSubProject) && (
            <Column width={100} fixed="right">
              <HeaderCell>
                <span>ออนไลน์</span>
              </HeaderCell>
              <Cell>
                {(rowData) => {
                  return (
                    <Checkbox
                      value={rowData.id}
                      checked={defaultCheckedIsOnline(rowData)}
                      onChange={(value, checked) => {
                        onClickOnline(value, checked, rowData)
                      }}
                      disabled={isDisableOnline || !rowData.enableOnline}
                    />
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>
        {pagination && (
          <TablePagination
            lengthMenu={lengthMenu}
            activePage={page}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={totalSize}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />
        )}

        {/* <Pagination
          prev
          last
          next
          first
          size="lg"
          pages={pageCount}
          activePage={activePage}
          onSelect={handleChangePage}
          disabled={isEmpty(tableData)}
        /> */}
      </Panel>
    </div>
  )
}
